export default {
  'menu.exception.404': '404',
  'exception.result.404.description': '抱歉，页面不见了～',
  'exception.result.404.retry': '重试',
  'exception.result.404.back': '返回',
};
